/*----- Core -----*/
import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color		  from '../../commons/Color'

/*----- Styles -----*/
const common = `
	margin: 16px 0;
`
const H1 = styled.h1`
	${ Montserrat(50, 600, Color.grey) };
	${ common }
`
const H2 = styled.h2`
	${ Montserrat(40, 600, Color.grey) };
	${ common }
`
const H3 = styled.h3`
	${ Montserrat(30, 600, Color.grey) };
	${ common }
`
const H4 = styled.h4`
	${ Montserrat(20, 600, Color.grey) };
	${ common }
`
const H5 = styled.h5`
	${ Montserrat(14, 600, Color.grey) };
	${ common }
`
const H6 = styled.h6`
	${ Montserrat(12, 600, Color.grey) };
	${ common }
`

/*----- Component -----*/
function Title({ content, size}) {
	switch (size) {
		case 1:
			return <H1 className="custom-title">{content}</H1>
		case 2:
			return <H2 className="custom-title">{content}</H2>
		case 3:
			return <H3 className="custom-title">{content}</H3>
		case 4:
			return <H4 className="custom-title">{content}</H4>
		case 5:
			return <H5 className="custom-title">{content}</H5>
		case 6:
			return <H6 className="custom-title">{content}</H6>
		default:
			return <H1 className="custom-title">{content}</H1>		
	}
	
}

export default Title

/*----- PropTypes -----*/
Title.propTypes = {
  size:   PropTypes.number.isRequired,
  content: PropTypes.string.isRequired
}
